import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import { getAppData } from '@/utils'
import actions from './actions'
import state from './state'

export default {
	namespaced : true,
	state,
	getters    : {
		hasMailPoet    : state => null !== state.config.hasMailPoet ? state.config.hasMailPoet : getAppData('hasMailPoet'),
		mailPoetLists  : state => state.config.mailPoetLists.length ? state.config.mailPoetLists : getAppData('mailPoetLists'),
		mailPoetFields : state => state.config.mailPoetFields.length ? state.config.mailPoetFields : getAppData('mailPoetFields'),
		wooKey         : state => state.wooKey.id ? state.wooKey : getAppData('wooKey', state.wooKey),
		isWooActive    : state => null !== state.config.isWooActive ? state.config.isWooActive : getAppData('isWooActive'),
		isWooConnected : state => null !== state.config.isWooConnected ? state.config.isWooConnected : getAppData('isWooConnected'),
	},
	mutations : {
		setWooKey (state, payload) {
			state.wooKey = payload
		},
		setWpCampaigns (state, payload) {
			if (isArray(payload)) {
				state.campaigns = payload
			}
		},
		setWpTaxonomies (state, payload) {
			if (isObject(payload)) {
				state.taxonomies = payload
			}
		},
		setWooConnected (state, payload) {
			state.config.isWooConnected = payload
		},
		setWpConfig (state, payload) {
			if (isObject(payload)) {
				state.config = payload
			}
		},
		setWpPosts (state, payload) {
			if (isArray(payload)) {
				state.posts = payload
			}
		},
		setWpPostTypes (state, payload) {
			if (isArray(payload)) {
				state.postTypes = payload
			}
		},
	},
	actions,
}
